import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("(?:journeyId|budgetId|expenseId|participantId|payerMemberId|recordedByMemberId|voidedByMemberId|memberId|ownerMemberId|creatorMemberId|createdByMemberId|conversationId)"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/** Private Journey expense ledger — Planning finance only (no split/payment modules). */
export const journeyExpenseApi = {
  list: (journeyId) => travelClient.get(
    travelEndpoints.journeyExpenses(journeyId),
    snowflakeJson,
  ),
  getSummary: (journeyId) => travelClient.get(
    travelEndpoints.journeyExpenseSummary(journeyId),
    snowflakeJson,
  ),
  get: (journeyId, expenseId) => travelClient.get(
    travelEndpoints.journeyExpense(journeyId, expenseId),
    snowflakeJson,
  ),
  create: (journeyId, body) => travelClient.post(
    travelEndpoints.journeyExpenses(journeyId),
    body,
    snowflakeJson,
  ),
  update: (journeyId, expenseId, body) => travelClient.patch(
    travelEndpoints.journeyExpense(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
  void: (journeyId, expenseId, body) => travelClient.post(
    travelEndpoints.journeyExpenseVoid(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
  shareToChat: (journeyId, expenseId, body = { confirm: true }) => travelClient.post(
    travelEndpoints.journeyExpenseChatShare(journeyId, expenseId),
    body,
    snowflakeJson,
  ),
};
